import {i18n} from '@netx/core/i18n';
import {Locales} from '@netx/core-next/locales';

import {
	StatDateType,
	StatQueryObjectType,
	StatType,
	StatQueryStatusType,
} from './constants';

export const StatsLabel = {
	ROUTE: i18n.t('i18n.statistics'),
};

export const StatDateTypeLabel: Record<StatDateType, string> = <const>{
	[StatDateType.TODAY]: i18n.t('i18n.today'),
	[StatDateType.THIS_WEEK]: i18n.t('i18n.thisWeek'),
	[StatDateType.THIS_MONTH]: i18n.t('i18n.thisMonth'),
	[StatDateType.THIS_YEAR]: i18n.t('i18n.thisYear'),
	[StatDateType.SELECTED_DATE]: i18n.t('i18n.selectedDate'),
	[StatDateType.BEFORE_DATE]: i18n.t('i18n.beforeDate'),
	[StatDateType.AFTER_DATE]: i18n.t('i18n.afterDate'),
	[StatDateType.BETWEEN_DATES]: i18n.t('i18n.betweenDates'),
};

export const StatTypeLabel: Record<StatType, string> = <const>{
	[StatType.APPROVED_DOWNLOAD_REQUEST_ASSETS]: i18n.t(
		'i18n.approvedDownloadRequestAssets',
	),
	[StatType.APPROVED_DOWNLOAD_REQUESTS]: i18n.t(
		'i18n.approvedDownloadRequests',
	),
	// [StatType.ASSET_ARCHIVED]: i18n.t('i18n.assetsArchived'),
	[StatType.ASSET_DOWNLOADS]: i18n.t('i18n.assetDownloads'),
	// [StatType.ASSET_UNARCHIVED]: i18n.t('i18n.assetsUnarchived'),
	[StatType.ASSETS_CHECKED_IN]: i18n.t('i18n.assetsCheckedIn'),
	[StatType.ASSETS_CHECKED_OUT]: i18n.t('i18n.assetsCheckedOut'),
	[StatType.ASSETS_DELETED]: i18n.t('i18n.assetsDeleted'),
	[StatType.ASSETS_IMPORTED]: i18n.t('i18n.assetsImported'),
	[StatType.ASSETS_LINKED]: i18n.t('i18n.assetsLinked'),
	[StatType.ASSETS_PLACED]: i18n.t('i18n.assetsPlaced'),
	// [StatType.ASSETS_PROCESSED]: i18n.t('i18n.assetsProcessed'),
	[StatType.ASSETS_SEARCHED]: i18n.t('i18n.assetsSearched'),
	[StatType.ASSETS_VIEWED]: i18n.t('i18n.assetsViewed'),
	[StatType.CATEGORIES_DELETED]: i18n.t('i18n.categoriesDeleted'),
	[StatType.CATEGORIES_VIEWED]: i18n.t('i18n.categoriesViewed'),
	[StatType.DENIED_DOWNLOAD_REQUEST_ASSETS]: i18n.t(
		'i18n.deniedDownloadRequestAssets',
	),
	[StatType.DENIED_DOWNLOAD_REQUESTS]: i18n.t('i18n.deniedDownloadRequests'),
	[StatType.FILE_DOWNLOADS]: i18n.t('i18n.fileDownloads'),
	[StatType.SESSION_EXPIRATION]: i18n.t('i18n.sessionExpiration'),
	[StatType.SHARED_ASSETS]: i18n.t('i18n.sharedAssets'),
	[StatType.SHARED_FILES]: i18n.t('i18n.sharedFiles'),
	[StatType.USER_LOGINS]: i18n.t('i18n.userLogins'),
};

export const StatUsageLabel = {};

export const StatUsageTitle = {
	ASSETS: i18n.t('i18n.assets'),
	BANDWIDTH: i18n.t('i18n.dataTransfer'),
	DETAILS: i18n.t('i18n.details'),
	JOBS: i18n.t('i18n.jobs'),
	STORAGE: i18n.t('i18n.storage'),
	USERS: i18n.t('i18n.users'),
};

export const StatQueryObjectTypeLabel: Record<StatQueryObjectType, string> = {
	[StatQueryObjectType.ASSET_ID]: i18n.t('i18n.assetId'),
	[StatQueryObjectType.CATEGORY_ID]: i18n.t('i18n.categoryId'),
	[StatQueryObjectType.OBJECT_ID]: i18n.t('i18n.objectId'),
	[StatQueryObjectType.STATUS]: i18n.t('i18n.status'),
	[StatQueryObjectType.USER_ID]: i18n.t('i18n.userId'),
};

export const StatQueryStatusTypeLabel: Record<StatQueryStatusType, string> = {
	[StatQueryStatusType.APPROVED]: i18n.t('i18n.approved'),
	[StatQueryStatusType.DENIED]: i18n.t('i18n.denied'),
	[StatQueryStatusType.PENDING_APPROVAL]: i18n.t('i18n.pendingApproval'),
};

export const StatQueryListMessage = {
	NO_RECORDS: i18n.t('i18n.noRecords'),
	NO_MATCHING_RECORDS: i18n.t('i18n.noMatchingRecords'),
	ERROR: i18n.t('i18n.error'),
};

export const StatQueryListColumnLabel = Locales((i18n) => ({
	USER: i18n('i18n.user'),
	ITEM: i18n('i18n.item'),
	DATE: i18n('i18n.date'),
	DOMAIN: i18n('i18n.domain'),
	DETAILS: i18n('i18n.details'),
}));
